module.exports = __webpack_public_path__ + "static/media/info_icon_vector_orange.6134a380.svg";